import { apiClient } from '@/shared/api';
import type { Journey, PaginatedJourneys } from './types';

interface ListJourneysParams {
  page?: number;
  limit?: number;
  search?: string;
  converted?: boolean | null;
}

export const journeysApi = {
  list: ({ page = 1, limit = 5, search, converted }: ListJourneysParams = {}) => {
    const params = new URLSearchParams();
    params.set('page', page.toString());
    params.set('limit', limit.toString());
    if (search) params.set('search', search);
    if (converted !== null && converted !== undefined) {
      params.set('converted', converted.toString());
    }
    return apiClient.get<PaginatedJourneys>(`/journeys?${params}`);
  },

  getByCustomer: (customerId: string) =>
    apiClient.get<{ customerId: string; sessions: Journey[]; count: number }>(
      `/journeys/${encodeURIComponent(customerId)}`
    ),
};
